/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_ColumnInputs */

const en_gc_resources_compare_column = /** @type {(inputs: Gc_Resources_Compare_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What matters`)
};

const zh_gc_resources_compare_column = /** @type {(inputs: Gc_Resources_Compare_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关注点`)
};

/**
* | output |
* | --- |
* | "What matters" |
*
* @param {Gc_Resources_Compare_ColumnInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_column = /** @type {((inputs?: Gc_Resources_Compare_ColumnInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_ColumnInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_column(inputs)
	return zh_gc_resources_compare_column(inputs)
});
export { gc_resources_compare_column as "gc.resources.compare.column" }